import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-dashed border-border bg-bg-subtle/50 p-10 text-center flex flex-col items-center gap-3',
        className,
      )}
    >
      {Icon && (
        <div className="h-12 w-12 rounded-pill bg-bg-surface border border-border-subtle flex items-center justify-center text-fg-3">
          <Icon className="h-5 w-5" />
        </div>
      )}
      <div>
        <h3 className="font-display font-bold text-base text-fg-1">{title}</h3>
        {description && <p className="text-sm text-fg-3 mt-1 max-w-md">{description}</p>}
      </div>
      {action}
    </div>
  )
}
